export const formatDate = (currentDate: string) => {
    const date = new Date(currentDate);
    const getDay = date.getDate();
    const getMonth = date.getMonth() + 1;
    const year = date.getFullYear();
    const day = getDay < 10 ? `0${getDay}` : getDay;
    const month = getMonth < 10 ? `0${getMonth}` : getMonth;

    return `${day} / ${month} / ${year}`;
};

export const getYearFromDate = (currentDate: string) => {
    if (currentDate) {
        const date = new Date(currentDate);

        return date.getFullYear();
    }

    return;
};
